module.exports = __webpack_public_path__ + "img/water.3c52c40f.svg";